@use '~/theme/theme' as *;

.title {
  color: color(grey-800);
  margin-bottom: spacing(3);
}

.row {
  display: flex;
}

.rowContainer {
  color: color(grey-800);
  display: flex;
  text-align: right;
  flex-direction: column;
  gap: spacing(1);
  min-width: 340px;
  padding-top: spacing(1.5);
  padding-bottom: spacing(1.5);
  border-bottom: border(grey-400);

  &:last-of-type {
    border-bottom: none;
  }
}

.stampContainer {
  position: relative;
}

.deleteStampButton {
  position: absolute;
  top: spacing(0.75);
  right: -36px;
}

.totalRow {
  display: flex;
  align-items: center;
}

.label {
  min-width: 180px;
  text-align-last: left;
}

.amount {
  min-width: 120px;
  flex-grow: 1;
}

.total {
  color: color(grey-800);
}

.error {
  color: color(lobster-800);
}
